import * as jobOnes from '../../job/stage/Id';

export const estimateExtendedWorkflowIds = [
	//
	// requestType = estimate
	//

	...jobOnes.estimateExtendedWorkflowIds,
] as const;

export const orderExtendedWorkflowIds = [
	//
	// requestType = order
	//

	...jobOnes.orderExtendedWorkflowIds,
] as const;

export const extendedWorkflowIds = [
	'fileProcessing',

	//
	// requestType = estimate
	//

	...estimateExtendedWorkflowIds,

	//
	// requestType = order
	//

	...orderExtendedWorkflowIds,
] as const;

export const ids = [
	//
	// common stages
	//

	'draft',
	'design',
	'designSimple',
	'review',
	'qa',
	...extendedWorkflowIds,
] as const;

export const reportIds = ['design', 'qa', 'review'] as const;

export const jobInheritedIds = [...jobOnes.aiStageIds] as const;
